export default "__VITE_ASSET__nbW5od5n__"